import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-bundle-removal-dialog',
  templateUrl: './confirm-bundle-removal-dialog.component.html',
  styleUrls: ['./confirm-bundle-removal-dialog.component.scss']
})
export class ConfirmBundleRemovalDialogComponent implements OnInit {
  bundles: any[] = [];
  flowData: any;

  constructor(
    public dialogRef: MatDialogRef<ConfirmBundleRemovalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.bundles = data.bundles || [];
      this.flowData = data.flowData || {};
    }
  }

  ngOnInit(): void {
  }

  proceed(): void {
    this.dialogRef.close('proceed');
  }

  cancel(): void {
    this.dialogRef.close();
  }

  getBundleNames(): string {
    if (this.bundles.length === 1) {
      return this.bundles[0].title || 'a bundle';
    } else {
      const names = this.bundles.map(b => b.title || 'unnamed bundle').join(', ');
      return names;
    }
  }
}
